export default "__VITE_ASSET__V0REKNw4__"